export enum WidgetTypeEnum {
  pie = 'pie',
  gauge = 'gauge',
  average = 'average',
  indicators = 'indicators',
  table = 'table',
  volume = 'volume',
  rate = 'rate',
  icons = 'icons',
  consumption = 'consumption',
}
